// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/user/user_admin.proto (package ga.config_manager.user, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { UserScope } from "../../bo/user_scope/user_scope_pb";
import { file_ga_bo_user_scope_user_scope } from "../../bo/user_scope/user_scope_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/user/user_admin.proto.
 */
export const file_ga_config_manager_user_user_admin: GenFile = /*@__PURE__*/
  fileDesc("CidnYS9jb25maWdfbWFuYWdlci91c2VyL3VzZXJfYWRtaW4ucHJvdG8SFmdhLmNvbmZpZ19tYW5hZ2VyLnVzZXIiCwoJTWVSZXF1ZXN0IjgKCk1lUmVzcG9uc2USKgoFc2NvcGUYAiABKAsyGy5nYS5iby51c2VyX3Njb3BlLlVzZXJTY29wZULpAQoaY29tLmdhLmNvbmZpZ19tYW5hZ2VyLnVzZXJCDlVzZXJBZG1pblByb3RvUAFaRXhkZXZ0ZWFtLmNvbS9hOHIvY29uZmlnLW1hbmFnZXIvaW50ZXJuYWwvcHJvdG8vZ2EvY29uZmlnX21hbmFnZXIvdXNlcqICA0dDVaoCFUdhLkNvbmZpZ01hbmFnZXIuVXNlcsoCFUdhXENvbmZpZ01hbmFnZXJcVXNlcuICIUdhXENvbmZpZ01hbmFnZXJcVXNlclxHUEJNZXRhZGF0YeoCF0dhOjpDb25maWdNYW5hZ2VyOjpVc2VyYgZwcm90bzM", [file_ga_bo_user_scope_user_scope]);

/**
 * @generated from message ga.config_manager.user.MeRequest
 */
export type MeRequest = Message<"ga.config_manager.user.MeRequest"> & {
};

/**
 * Describes the message ga.config_manager.user.MeRequest.
 * Use `create(MeRequestSchema)` to create a new message.
 */
export const MeRequestSchema: GenMessage<MeRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_user_user_admin, 0);

/**
 * @generated from message ga.config_manager.user.MeResponse
 */
export type MeResponse = Message<"ga.config_manager.user.MeResponse"> & {
  /**
   *  User user = 1; // deprecated
   *
   * @generated from field: ga.bo.user_scope.UserScope scope = 2;
   */
  scope?: UserScope;
};

/**
 * Describes the message ga.config_manager.user.MeResponse.
 * Use `create(MeResponseSchema)` to create a new message.
 */
export const MeResponseSchema: GenMessage<MeResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_user_user_admin, 1);

